/**
 * do things on viewport changes
 * DomNodeElements have to have a class starting with "vo-"
 * everthing afterwards the class prefix is used as method name transformed into camelCase with a pattern as follows:
 * if the method doesn't exists the class is removed when the element occurs in the viewport (to be tested)
 * @type {Object}
 */
oyc.ViewportObserver = {
  dependencies: ['Delay'],
  selectors: {
    scrollContainer: window,
    items: '[class^="vo-"],[class*=" vo-"]'
  },
  tolerance: 20,
  processing: false,
  init: function () {
    var items = $(this.selectors.items);
    if (0 < items.length) {
      this.scrollContainer = $(this.selectors.scrollContainer);
      this.clickItems = $(this.selectors.items);
      this.addEvents();
      this.scroll();
    }
  },
  addEvents: function () {
    $(window).on('scroll resize', this.scroll.bind(this));
  },
  scroll: function () {
    if (!this.processing) {
      this.processing = true;
      // request animation frame
      oyc.Delay.init(this.toggleVo, 50, 'vo-toggle', this);
    }
  },
  resize: function () {
    this.Delay.init(this.calcAspectRatio, 50, 'viewportObserver-resize', this);
    this.Delay.init(this.setVhSize, 50, 'viewportObserver-vhSize', this);
  },
  calcAspectRatio: function () {
    let aspectRatio = window.innerHeight / window.innerWidth;
    document.documentElement.style.setProperty('--aspect-ratio', aspectRatio.toString());
  },
  /**
   * callback function of scroll event
   * traversing through the items of the class
   */
  toggleVo: function () {
    this.items.each(this.toggleVoItem.bind(this));
  },
  /**
   * executed after scroll event looking up for an item which specific method is to be executed
   * @param {int} i
   * @param {DOMNodeElement} el
   */
  toggleVoItem: function (i, el) {
    let voClass = el.className.match(/vo-([^ ]+)/);
    voClass = (voClass === null ? 'False' : voClass[1]);
    const jEl = $(el);
    const voMethod = 'toggleVo' + voClass.substr(0, 1).toUpperCase() + voClass.substr(1);
    let parameters;
    if (voMethod in this) {
      parameters = this[voMethod](el);
      var item = parameters.item || jEl;
    }
    if (typeof item !== 'undefined' && item.isInViewport()) {
      $(el).addClass(voClass);
    } else {
      $(el).removeClass(voClass);
    }

    // update this.items on last item to process so toggles that should take place only once are no longer considered
    if (this.items.index(el) === this.items.length - 1) {
      this.processing = false;
      this.clickItems = $(this.selectors.items);
    }
  },
  /**
   * @param {DOMNodeElement} el
   * @returns {Object}
   */
  toggleVoSticky: function (el) {
    return {item: $(el).parent(), tolerance: 0};
  },
  /**
   *
   * @param {DOMNodeElement} el
   * @returns {boolean}
   */
  toggleVoHideAfterInit: function (el) {
    var item = $(el);
    this.Delay.init(item.removeClass, 500, 'vo-hideAfterInit', item, 'vo-hideAfterInit');
    window.setTimeout('oyc.ViewportObserver.items = $(oyc.ViewportObserver.selectors.items)', 600);
    return false;
  },
  toggleVoWaitFor: function (el) {
    var jEl = $(el);
    var selector = jEl.data('vo-wait-for');
    if (typeof selector !== 'undefined') {
      var callback = jEl.data('vo-wait-for-callback');
      if (typeof callback !== 'undefined') {
        if (callback in this) {
          callback = this[callback];
        }
        callback();
        this.checkForElement(selector).then(callback.bind(null, el, selector));
      }
    }
    return false;
  },
  checkForElement: function (selector) {
    if (!document.querySelector(selector) !== null) {
      return this.waitFor().then(() => this.checkForElement(selector));
    } else {
      return Promise.resolve(true);
    }
  },
  waitFor: function () {
    return new Promise((resolve) => setTimeout(resolve, 50));
  },
  isPortrait: function () {
    return 1 < parseFloat(window.getComputedStyle(document.documentElement).getPropertyValue('--aspect-ratio'));
  },
  setVhSize: function () {
    if (device.mobile()) {
      var vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', vh + 'px');
    }
  },
  showOnMobile: function (el, selector) {
    if (device.mobile()) {
      $(selector).show();
    } else {
      $(selector).hide();
    }
  }
};
/**
 * @todo implement respect tolerance
 * @param {int} tolerance inm percentage
 * @returns {boolean|boolean}
 */
$.fn.isInViewport = function (tolerance) {
  var tolerance = tolerance || 0;
  var elementHeight = $(this).outerHeight();
  var elementTop = $(this).offset().top;
  var elementBottom = elementTop + elementHeight;
  var viewportTop = $(window).scrollTop() - elementHeight * tolerance / 100;
  var viewportBottom = viewportTop + $(window).height() + elementHeight * tolerance / 100;
  return elementBottom > viewportTop && elementTop < viewportBottom;
};
/**
 * to check if an element positioned fixed or absolute is overlapping the current
 * @param element
 * @returns {boolean}
 */
$.fn.isOverlappedBy = function (element) {
  if ('length' in element && element.length && element.isInViewport()) {
    var item = $(this);
    return element.offset().top < item.offset().top + item.outerHeight()
  }
};
